import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { paymentPlansRepo } from '../repo/paymentPlansRepo'
import { logAudit } from '@/lib/audit'

export function useCustomerPaymentPlans(customerId: string | undefined) {
  return useQuery({
    queryKey: ['payment-plans', customerId],
    queryFn: () => customerId ? paymentPlansRepo.findByCustomer(customerId) : [],
    enabled: !!customerId,
  })
}

export function useCreatePaymentPlan() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (plan: any) => paymentPlansRepo.create(plan),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['payment-plans', data.customer_id] })
      logAudit({
        action: 'create_payment_plan',
        resource_type: 'payment_plan',
        resource_id: data.id,
        client_id: data.client_id,
      })
    },
  })
}

export function useUpdatePaymentPlan() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: any }) =>
      paymentPlansRepo.update(id, updates),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['payment-plans', data.customer_id] })
      logAudit({
        action: 'update_payment_plan',
        resource_type: 'payment_plan',
        resource_id: data.id,
        client_id: data.client_id,
      })
    },
  })
}

export function useDeletePaymentPlan() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => paymentPlansRepo.delete(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['payment-plans'] })
      logAudit({
        action: 'delete_payment_plan',
        resource_type: 'payment_plan',
        resource_id: id,
      })
    },
  })
}
